import { gql } from "@apollo/client";

// Appraisals (see wfc-server resolvers/appraisalResolver).

export const updateAppraisalSettingsMutation = gql`
    mutation updateAppraisalSettings($input: AppraisalSettingsInput!){
        updateAppraisalSettings(input: $input){
            message
            response
        }
    }
`;

export const saveAppraisalTemplateMutation = gql`
    mutation saveAppraisalTemplate($input: AppraisalTemplateInput!){
        saveAppraisalTemplate(input: $input){
            message
            response
        }
    }
`;

export const archiveAppraisalTemplateMutation = gql`
    mutation archiveAppraisalTemplate($id: String!, $archived: Boolean){
        archiveAppraisalTemplate(id: $id, archived: $archived){
            message
            response
        }
    }
`;

export const newAppraisalMutation = gql`
    mutation newAppraisal($input: NewAppraisalInput!){
        newAppraisal(input: $input){
            message
            response
        }
    }
`;

export const takeAppraisalMutation = gql`
    mutation takeAppraisal($id: String!){
        takeAppraisal(id: $id){
            message
            response
        }
    }
`;

export const reassignAppraisalMutation = gql`
    mutation reassignAppraisal($id: String!, $reviewerEmployeeId: String!){
        reassignAppraisal(id: $id, reviewerEmployeeId: $reviewerEmployeeId){
            message
            response
        }
    }
`;

export const cancelAppraisalMutation = gql`
    mutation cancelAppraisal($id: String!, $reason: String, $stopRepeating: Boolean){
        cancelAppraisal(id: $id, reason: $reason, stopRepeating: $stopRepeating){
            message
            response
        }
    }
`;

export const saveAppraisalReviewMutation = gql`
    mutation saveAppraisalReview($input: AppraisalReviewInput!){
        saveAppraisalReview(input: $input){
            message
            response
        }
    }
`;

export const submitAppraisalSelfAssessmentMutation = gql`
    mutation submitAppraisalSelfAssessment($input: AppraisalOfficerInput!){
        submitAppraisalSelfAssessment(input: $input){
            message
            response
        }
    }
`;

export const signOffAppraisalMutation = gql`
    mutation signOffAppraisal($input: AppraisalOfficerInput!){
        signOffAppraisal(input: $input){
            message
            response
        }
    }
`;

export const stopAppraisalScheduleMutation = gql`
    mutation stopAppraisalSchedule($id: String!){
        stopAppraisalSchedule(id: $id){
            message
            response
        }
    }
`;

// the company's own form as a template: upload, then prepare
export const getAppraisalTemplateUploadUrlMutation = gql`
    mutation getAppraisalTemplateUploadUrl($fileName: String!){
        getAppraisalTemplateUploadUrl(fileName: $fileName){
            message
            response
        }
    }
`;

export const prepareAppraisalTemplatePdfMutation = gql`
    mutation prepareAppraisalTemplatePdf($key: String!, $fileName: String!){
        prepareAppraisalTemplatePdf(key: $key, fileName: $fileName){
            message
            response
        }
    }
`;
